import { getValueFromUserPref } from './user-pref-cookie-service';

export const normalizeUkPostcode = (postcode: string | undefined | null): string =>
    (postcode || '').trim().toUpperCase();

export const isUkPostcode = (postcode: string): boolean => {
    // http://stackoverflow.com/questions/164979/uk-postcode-regex-comprehensive#answer-17507615

    const regex =
        /^\s*(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4})\s*$/i;
    return regex.test(normalizeUkPostcode(postcode));
};

/** Returns only a valid postcode from the SRP/BRP gt_userPref cache. */
export const getPrefilledUkPostcode = (): string => {
    if (typeof document === 'undefined') {
        return '';
    }
    const postcode = normalizeUkPostcode(getValueFromUserPref('location'));
    return postcode && isUkPostcode(postcode) ? postcode : '';
};
